import { Plane, Car, Key, LogOut, MapPin } from "lucide-react";
import { tx } from "@/i18n";

const Row = ({ icon: Icon, label, value, rotate }) => (
  <span className="inline-flex items-start gap-1.5">
    <Icon className={`h-3.5 w-3.5 shrink-0 mt-0.5 text-muted-foreground ${rotate ? "rotate-90" : ""}`} />
    {label} <span className="font-medium text-foreground">{value}</span>
  </span>
);

const rows = (b) => {
  const ai = b.arrival_intake;
  const plane = ai.transport === "plane";
  if (b.type === "checkin") return [
    [Key, tx("Aankomst woning:"), ai.arrival_time],
    [plane ? Plane : Car, tx("Vervoer:"), plane ? tx("Vliegtuig") : tx("Auto")],
    plane && ai.airport_transfer && [MapPin, tx("Vanaf vliegveld:"), ai.airport_transfer === "taxi" ? tx("Taxi") : tx("Huurauto")],
    plane && ai.flight_in && [Plane, tx("Landen Alicante:"), ai.flight_in],
  ];
  return [
    [LogOut, tx("Vertrek woning:"), ai.departure_time],
    plane && ai.flight_out && [Plane, tx("Opstijgen Alicante:"), ai.flight_out, true],
  ];
};

export const IntakeSummary = ({ booking, compact = false }) => {
  if (!["checkin", "checkout"].includes(booking.type) || !booking.arrival_intake?.completed) return null;
  const items = rows(booking).filter(Boolean);
  return (
    <div className={compact ? "mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs rounded-md bg-primary/5 border border-primary/20 px-2.5 py-1.5 w-fit max-w-full" : "rounded-lg border border-border p-3 flex flex-col gap-1.5"}
      data-testid={`${compact ? "booking-intake" : "booking-detail-intake"}-${booking.id}`}>
      {!compact && <div className="font-semibold text-foreground">{tx("Info van de gast")}</div>}
      {items.map(([icon, label, value, rotate], i) => <Row key={i} icon={icon} label={label} value={value} rotate={rotate} />)}
    </div>
  );
};
